module.exports = __webpack_public_path__ + "img/cama-2-plazas.4d814f4a.svg";